<template>
    <div style="border:1px solid #D9D9D9; display:flex; border-radius:5px;"
         :style="{bottomBorder : bottomBorderZero ? '0px' : '', borderBottomLeftRadius : bottomBorderZero ? '0px' : '', borderBottomRightRadius : bottomBorderZero ? '0px' : ''}">
        <div style="flex:1;padding:8px 8px;">
            <div class="label" v-if="label" >{{label}}</div>
            <input :type="pType" class="input_contents" :placeholder="placeholderStr" :value="value" v-model="model" ref="inputEl" @keyup="keyup($event)"
               :style="styles" @click="click($event)" :readonly="isReadOnly">
        </div>
        <div style="">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FormInput2",
        props : {
            label : {
                type : String,
                default : '',
            },
            clickInput : {
                type : Function,
                default : () => {}
            },
            placeholderStr : {
                type : String,
                default : ''
            },
            value : {
                type : String,
                default : '',
            },
            type : {
                type : String,
                default : 'text'
            },
            isReadOnly : {
                type : Boolean,
                default : false
            },
            pWidth : {
                type : String,
                default : '',
            },
            bottomBorderZero : {
                type : Boolean,
                default : false,
            }
        },
        data(){
            return {
                pType : '',
                styles : {},
            }
        },
        methods : {
            click(e){
                if(this.type === 'number') e.currentTarget.select();
                this.clickInput(e);
            },
            keyup(e){
                if(this.type === 'number'){
                    const target = e.currentTarget;
                    const rgx1 = /\D/g;
                    const rgx2 = /(\d+)(\d{3})/;
                    let num = target.value.replace(rgx1,"");

                    while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');
                    this.$emit("input", "" + num);
                }
            },
            detectTypeChange(){
                if(this.type === 'phone') {
                    this.pType = 'tel';
                }else if(this.type === 'number') {
                    this.pType = 'tel';
                    this.styles.textAlign = 'right';
                }else if(this.type === 'yyyy/mm/dd'){
                    this.pType = 'tel';
                }else {
                    this.pType = this.type;
                }
            }
        },
        computed: {
            model: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        },
        watch : {
            type(){
                this.detectTypeChange();
            }
        },

        mounted(){
            if(this.type === 'phone') this.$Util.setPhoneFormatter(this.$refs.inputEl);
            if(this.type === 'yyyy/mm/dd') this.$Util.setYYYYMMDDFormmater(this.$refs.inputEl);
        },
        created(){
            this.detectTypeChange();

            if(this.pWidth !== '') {
                this.styles.width = this.pWidth;
                this.styles.flex = 'unset';
            }
        }
    }
</script>

<style scoped>
    * {font-family: var(--global-font-family);}
    .label{font-size:12px; color:#808080}
    .input_contents{border:0px;outline: none; color:#606060; font-size:14px; padding:0px; margin-top:3px; width:100%;}
</style>